import React from 'react';
import InteractionItem from '../../InteractionItem/InteractionItem';
import WhatsAppChat from '../../WhatsAppChat/WhatsAppChat';
import EmailChat from '../../EmailChat/EmailChat';
import AnnotationsPanel from '../../AnnotationsPanel';
import CallsPanel from '../../CallsPanel/CallsPanel';

const ManagementTimeline = ({
  interactions,
  expedientId,
  debtorId,
  debtor,
  activeTab,
  annotations,
  onAnnotationAdded,
  expedientType,
}) => {
  // Filter interactions by type
  const filterInteractions = (interactions, tab) => {
    if (tab === 'all') return interactions;
    if (tab === 'whatsapp') {
      return interactions.filter(i => i.type === 'whatsapp_sent' || i.type === 'whatsapp_response');
    }
    if (tab === 'email') {
      return interactions.filter(
        i => i.type === 'email_sent' || i.type === 'email_opened' || i.type === 'email_response'
      );
    }
    if (tab === 'call') {
      return interactions.filter(i => i.type?.includes('call'));
    }
    if (tab === 'sms') {
      return interactions.filter(i => i.type === 'sms_sent' || i.type === 'sms_opened' || i.type === 'sms_responded');
    }
    // other
    return interactions.filter(i => {
      const whatsapp = i.type === 'whatsapp_sent' || i.type === 'whatsapp_response';
      const email = i.type === 'email_sent' || i.type === 'email_opened' || i.type === 'email_response';
      const call = i.type?.includes('call');
      const sms = i.type === 'sms_sent' || i.type === 'sms_opened' || i.type === 'sms_responded';
      return !whatsapp && !email && !call && !sms;
    });
  };

  const filteredInteractions = filterInteractions(interactions, activeTab);
  const whatsappInteractions = interactions.filter(i => i.type === 'whatsapp_sent' || i.type === 'whatsapp_response');
  const emailInteractions = interactions.filter(
    i => i.type === 'email_sent' || i.type === 'email_opened' || i.type === 'email_response'
  );

  // For WhatsApp/Email tabs, only show chat (no timeline)
  // For "all" tab, show timeline with ALL interactions including WhatsApp/Email
  // For other tabs, show timeline with filtered interactions (excluding WhatsApp/Email)
  const timelineInteractions =
    activeTab === 'whatsapp' || activeTab === 'email'
      ? []
      : activeTab === 'all'
        ? filteredInteractions // Include all in timeline for "all" tab
        : filteredInteractions.filter(i => i.type !== 'whatsapp_sent' && i.type !== 'whatsapp_response');

  // Sort interactions by date (newest first)
  const sortedInteractions = [...timelineInteractions].sort((a, b) => {
    const dateA = a.date ? new Date(a.date).getTime() : 0;
    const dateB = b.date ? new Date(b.date).getTime() : 0;
    return dateB - dateA; // Descending order: newest first
  });

  // Chat views for WhatsApp and Email tabs
  const hasWhatsApp = activeTab === 'whatsapp';
  const hasEmail = activeTab === 'email';
  // Show timeline when there are interactions to display
  const shouldShowTimeline = timelineInteractions.length > 0;

  // Show annotations panel for annotations tab
  if (activeTab === 'annotations') {
    return (
      <div className='overflow-y-auto'>
        <AnnotationsPanel expedientId={expedientId} annotations={annotations} onAnnotationAdded={onAnnotationAdded} />
      </div>
    );
  }

  // Show calls panel for calls tab
  if (activeTab === 'call') {
    return (
      <div className='overflow-y-auto'>
        <CallsPanel expedientId={expedientId} debtorId={debtorId} debtor={debtor} />
        {shouldShowTimeline && (
          <div className='overflow-y-auto p-4 border-t border-slate-200 min-h-[calc(100vh-410px)] max-h-[calc(100vh-410px)]'>
            <h4 className='text-sm font-semibold text-slate-700 mb-4 mt-4'>Historial de llamadas</h4>
            <div className='space-y-2'>
              {sortedInteractions.map((interaction, index, array) => (
                <InteractionItem
                  key={`${interaction.interaction_id}-${index}`}
                  interactionItem={interaction}
                  isLast={index === array.length - 1}
                  expedientId={expedientId}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  if (
    filteredInteractions.length === 0 &&
    activeTab !== 'whatsapp' &&
    activeTab !== 'email' &&
    activeTab !== 'annotations' &&
    activeTab !== 'call'
  ) {
    return (
      <div className='text-center py-12'>
        <p className='text-sm text-slate-500'>No hay interacciones de este tipo.</p>
      </div>
    );
  }

  return (
    <div className='w-full'>
      {/* WhatsApp Chat Section */}
      {hasWhatsApp && (
        <div className='overflow-y-auto'>
          <WhatsAppChat interactions={whatsappInteractions} expedientId={expedientId} debtorId={debtorId} expedientType={expedientType} />
        </div>
      )}

      {/* Email Chat Section */}
      {hasEmail && (
        <div className='overflow-y-auto'>
          <EmailChat
            interactions={emailInteractions}
            expedientId={expedientId}
            debtorId={debtorId}
            debtor={debtor}
          />
        </div>
      )}

      {/* Timeline for interactions */}
      {shouldShowTimeline && (
        <div className='overflow-y-auto p-4'>
          <div className='space-y-2 mt-4 min-h-[calc(100vh-380px)] max-h-[calc(100vh-380px)]'>
            {sortedInteractions.map((interaction, index, array) => (
              <InteractionItem
                key={`${interaction.interaction_id}-${index}`}
                interactionItem={interaction}
                isLast={index === array.length - 1}
                expedientId={expedientId}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagementTimeline;
